import styled, { css } from 'styled-components';
import { ActionButton, FlexBox, Icon, StackPanel, PrimaryButton } from '@agilepoint/wat-react-ux';

export const StyledActionButton = styled(ActionButton)`
    .ap-button-label {
            margin: 0;
        }
`;

export const PlatformIcon = styled(Icon) <{ $platform: string }>`
    fill: ${({ $platform, theme: { semantics: { palette } } }) => ($platform === 'Android' ? '#3DDC84' : palette.black)};
`;

export const StyledFlexBox = styled(FlexBox) <{ $padding?: string, $margin?: string, $overflow?: string }>`
    padding: ${({ $padding }) => $padding};
    margin: ${({ $margin }) => $margin};
    overflow: ${({ $overflow }) => $overflow};
`;

export const StyledStackPanel = styled(StackPanel) <{
    padding?: string,
    margin?: string,
    maxHeight?: string,
    maxWidth?: string,
    overflow?: string,
    position?: string;
    top?: string;
    right?: string;
    bottom?: string;
    left?: string;
}>`
    margin: ${({ margin }) => margin};
    padding: ${({ padding }) => padding};
    max-height:${({ maxHeight }) => maxHeight};
    max-width:${({ maxWidth }) => maxWidth};
    overflow: ${({ overflow }) => overflow};
    position: ${({ position }) => position};
    top: ${({ top }) => top};
    right: ${({ right }) => right};
    bottom: ${({ bottom }) => bottom};
    left: ${({ left }) => left};
`;

export const primaryButtonStyles = css`
    &:hover, &:focus {
        color: #FFFFFF !important;
        fill: #FFFFFF !important;
    }
`;

export const StyledPrimaryButton = styled(PrimaryButton) <{ $width?: string }> `
    ${primaryButtonStyles};
`;
